import { render, staticRenderFns } from "./cardData.vue?vue&type=template&id=229245b7&scoped=true"
import script from "./cardData.vue?vue&type=script&lang=js"
export * from "./cardData.vue?vue&type=script&lang=js"
import style0 from "./cardData.vue?vue&type=style&index=0&id=229245b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229245b7",
  null
  
)

export default component.exports